"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _AdminRoutes = _interopRequireDefault(require("./AdminRoutes.js"));
var _DeploymentEvaluator = _interopRequireDefault(require("./components/DeploymentEvaluator"));
var _EndpointEvaluator = _interopRequireDefault(require("./components/EndpointEvaluator"));
var _PreviewQuest = _interopRequireDefault(require("./components/PreviewQuest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Root = function Root(_ref) {
  var errorLayout = _ref.errorLayout,
    registrationUrlsByRole = _ref.registrationUrlsByRole;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    path: "/d/:deploymentHash/:shortHash?",
    component: _DeploymentEvaluator["default"],
    componentProps: {
      errorLayout: errorLayout,
      registrationUrlsByRole: registrationUrlsByRole
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    exact: true,
    path: "/survey/:endpoint/:shortHash?",
    component: _EndpointEvaluator["default"]
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    path: "/quest/preview/quest/:assignmentId/:shortHash",
    component: _PreviewQuest["default"]
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    path: "/quest",
    component: _AdminRoutes["default"]
  }));
};
Root.propTypes = {
  errorLayout: _propTypes["default"].func,
  registrationUrlsByRole: _propTypes["default"].object
};
var _default = Root;
exports["default"] = _default;